import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'

export const constantBaseRoutes = [
  {
    path: '/login',
    meta:{title:'login'},
    icon:'',
    component: () => import('@/views/login/index'),
    children:[],
    hidden: true
  },
  {
    path: '/',
    meta:{title:''},
    icon:'',
    component: () => import('@/views/login/index'),
    children:[],
    hidden: true
  },
  {
    path: '/SystemManager',
    meta:{title:'系统管理',icon:'',},
    
    // component: () => import('@/views/largeScreen/index'),
    component:Layout,
    name:'UserManager',
    children:[
      {
        path:'/UserManager/List',
        component:()=>import('@/views/UserManager/List.vue'),
        name:'User',
        meta:{
          title:'员工管理',
          icon:''
        },
        hidden:false,
        children:[],
        permission:'Pages.User.View',
      },
      {
        path:'/DepartmentManager/List',
        component:()=>import('@/views/DepartmentManager/List.vue'),
        name:'User',
        meta:{
          title:'部门管理',
          icon:''
        },
        hidden:false,
        children:[],
        permission:'Pages.Department.View',
      },
      {
        path:'/RoleManager/List',
        component:()=>import('@/views/RoleManager/List.vue'),
        name:'Role',
        meta:{
          title:'角色管理',
          icon:''
        },
        hidden:false,
        children:[],
        permission:'Pages.RoleManager.View',
      },
      {
        path:'/DictionaryManager/List',
        component:()=>import('@/views/DictionaryManager/List.vue'),
        name:'Dictionary',
        meta:{
          title:'字典管理',
          icon:''
        },
        hidden:false,
        children:[],
        permission:'Pages.RoleManager.View',
      }
      
    ],
    hidden: true
  },
  // {
  //   path: '/UserManager',
  //   meta:{title:'员工管理',icon:'',},
    
  //   // component: () => import('@/views/largeScreen/index'),
  //   component:Layout,
  //   name:'UserManager',
  //   children:[
  //     {
  //       path:'/UserManager/List',
  //       component:()=>import('@/views/UserManager/List.vue'),
  //       name:'User',
  //       meta:{
  //         title:'员工管理',
  //         icon:''
  //       },
  //       hidden:false,
  //       children:[],
  //       permission:'Pages.User.View',
  //     }
  //   ],
  //   hidden: false
  // },
  // {
  //   path: '/DepartmentManager',
  //   meta:{title:'部门管理',icon:'',},
  //   // component: () => import('@/views/largeScreen/index'),
  //   component:Layout,
  //   name:'DepartmentManager',
  //   children:[
  //     {
  //       path:'/DepartmentManager/List',
  //       component:()=>import('@/views/DepartmentManager/List.vue'),
  //       name:'User',
  //       meta:{
  //         title:'部门管理',
  //         icon:''
  //       },
  //       hidden:false,
  //       children:[],
  //       permission:'Pages.Department.View',
  //     }
  //   ],
  //   hidden: false
  // },
  // {
  //   path: '/RoleManager',
  //   meta:{title:'角色管理',icon:'',},
  //   // component: () => import('@/views/largeScreen/index'),
  //   component:Layout,
  //   name:'RoleManager',
  //   children:[
  //     {
  //       path:'/RoleManager/List',
  //       component:()=>import('@/views/RoleManager/List.vue'),
  //       name:'Role',
  //       meta:{
  //         title:'角色管理',
  //         icon:''
  //       },
  //       hidden:false,
  //       children:[],
  //       permission:'Pages.RoleManager.View',
  //     }
  //   ],
  //   hidden: false
  // },
  {
    path: '/ProductManager',
    meta:{title:'设置',icon:'',},
    // component: () => import('@/views/largeScreen/index'),
    component:Layout,
    name:'productManager',
    children:[
      {
        path:'/ProductManager/List',
        component:()=>import('@/views/ProductManager/List.vue'),
        name:'Role',
        meta:{
          title:'产品管理',
          icon:''
        },
        hidden:false,
        children:[],
        permission:'Pages.productManager.View',
      },
      {
        path:'/PayManager/List',
        component:()=>import('@/views/PayManager/List.vue'),
        name:'Role',
        meta:{
          title:'支付通道',
          icon:''
        },
        hidden:false,
        children:[],
        permission:'Pages.PayManager.View',
      }
    ],
    hidden: true
  },
  {
    path: '/OrderManager',
    meta:{title:'订单管理',icon:'',},
    // component: () => import('@/views/largeScreen/index'),
    component:Layout,
    name:'OrderManager',
    children:[
      {
        path:'/NewOrder/List',
        component:()=>import('@/views/Order/NewOrder.vue'),
        name:'Role',
        meta:{
          title:'新单列表',
          icon:''
        },
        hidden:false,
        children:[],
        permission:'Pages.productManager.View',
      },
      {
        path:'/UpgradeOrder/List',
        component:()=>import('@/views/Order/UpgradeOrder.vue'),
        name:'Role',
        meta:{
          title:'升级单列表',
          icon:''
        },
        hidden:false,
        children:[],
        permission:'Pages.PayManager.View',
      },
      {
        path:'/NAllocateList/List',
        component:()=>import('@/views/Order/NAllocateList.vue'),
        name:'Role',
        meta:{
          title:'新单待分配-客服',
          icon:''
        },
        hidden:false,
        children:[],
        permission:'Pages.PayManager.View',
      },
      {
        path:'/NCAllocateList/List',
        component:()=>import('@/views/Order/NCAllocateList.vue'),
        name:'Role',
        meta:{
          title:'新单待分配-大客',
          icon:''
        },
        hidden:false,
        children:[],
        permission:'Pages.PayManager.View',
      },
      {
        path:'/UAllocateList/List',
        component:()=>import('@/views/Order/UAllocateList.vue'),
        name:'Role',
        meta:{
          title:'升级单待分配',
          icon:''
        },
        hidden:false,
        children:[],
        permission:'Pages.PayManager.View',
      }
    ],
    hidden: true
  },



  {
    path: '/CustomerManagent',
    meta:{title:'资源管理',icon:'',},
    // component: () => import('@/views/largeScreen/index'),
    component:Layout,
    name:'CustomerManagent',
    children:[
      {
        path:'/CustomerResources/List',
        component:()=>import('@/views/CustomerManagent/CustomerResources.vue'),
        name:'Role',
        meta:{
          title:'资源池',
          icon:''
        },
        hidden:false,
        children:[],
        permission:'Pages.CustomerResources.View',
      },
      {
        path:'/MyCustomer/List',
        component:()=>import('@/views/CustomerManagent/MyCustomer.vue'),
        name:'Role',
        meta:{
          title:'我的资源',
          icon:''
        },
        hidden:false,
        children:[],
        permission:'Pages.PayManager.View',
      },
      {
        path:'/ManAllocateList/List',
        component:()=>import('@/views/CustomerManagent/ManAllocateList.vue'),
        name:'User',
        meta:{
          title:'待分配-总监',
          icon:''
        },
        hidden:false,
        children:[],
        permission:'Pages.User.View',
      },
      {
        path:'/AllocateList/List',
        component:()=>import('@/views/CustomerManagent/AllocateList.vue'),
        name:'User',
        meta:{
          title:'待分配',
          icon:''
        },
        hidden:false,
        children:[],
        permission:'Pages.User.View',
      }
    ],
    hidden: true
  },
  {
    path: '/MenuManager',
    meta:{title:'菜单管理',icon:'',},
    // component: () => import('@/views/largeScreen/index'),
    component:Layout,
    name:'productManager',
    children:[
      {
        path:'/MenuManager/List',
        component:()=>import('@/views/MenuManager/List.vue'),
        name:'Role',
        meta:{
          title:'菜单管理',
          icon:''
        },
        hidden:false,
        children:[],
        permission:'Pages.MenuManager.View',
      },
    ],
    hidden: true
  },



  
  // {
  //   path: '/Agreement',
  //   meta:{title:'合同管理',icon:'',},
    
  //   // component: () => import('@/views/largeScreen/index'),
  //   component:Layout,
  //   name:'AgreementManage',
  //   children:[
  //     {
  //       path:'/Agreement/List',
  //       component:()=>import('@/views/Agreement/List.vue'),
  //       name:'Customer',
  //       meta:{
  //         title:'合同管理',
  //         icon:''
  //       },
  //       hidden:false,
  //       children:[],
  //       permission:'Pages.Customer.View',
  //     }
  //   ],
  //   hidden: false
  // },
  // {
  //   path: '/Work',
  //   meta:{title:'工作管理',icon:'',},
    
  //   // component: () => import('@/views/largeScreen/index'),
  //   component:Layout,
  //   name:'Work',
  //   children:[
  //     {
  //       path:'/Work/Scheduling',
  //       component:()=>import('@/views/Work/List.vue'),
  //       name:'Customer',
  //       meta:{
  //         title:'排班管理',
  //         icon:''
  //       },
  //       hidden:false,
  //       children:[],
  //       permission:'Pages.Customer.View',
  //     }
  //   ],
  //   hidden: false
  // },
  // {
  //   path: '/rule',
  //   meta:{title:'系统设置',icon:'',},
    
  //   // component: () => import('@/views/largeScreen/index'),
  //   component:Layout,
  //   name:'System',
  //   children:[
  //     {
  //       path:'/System/Rule',
  //       component:()=>import('@/views/System/Rule.vue'),
  //       name:'Rule',
  //       meta:{
  //         title:'角色管理',
  //         icon:''
  //       },
  //       hidden:false,
  //       children:[],
  //       permission:'Pages.Customer.View',
  //     },
  //     {
  //       path:'/System/UserRule',
  //       component:()=>import('@/views/System/UserRule.vue'),
  //       name:'Rule',
  //       meta:{
  //         title:'角色管理',
  //         icon:''
  //       },
  //       hidden:true,
  //       children:[],
  //       permission:'Pages.Customer.View',
  //     },
  //     {
  //       path:'/System/Project',
  //       component:()=>import('@/views/System/Project.vue'),
  //       name:'Rule',
  //       meta:{
  //         title:'模板管理',
  //         icon:''
  //       },
  //       hidden:false,
  //       children:[],
  //       permission:'Pages.Customer.View',
  //     },
  //     {
  //       path:'/System/ProjectDetail',
  //       component:()=>import('@/views/System/ProjectDetail.vue'),
  //       name:'Rule',
  //       meta:{
  //         title:'模板详情',
  //         icon:''
  //       },
  //       hidden:true,
  //       children:[],
  //       permission:'Pages.Customer.View',
  //     },
  //     {
  //       path:'/System/PhotosType',
  //       component:()=>import('@/views/System/PhotosType.vue'),
  //       name:'Rule',
  //       meta:{
  //         title:'图片集分类',
  //         icon:''
  //       },
  //       hidden:false,
  //       children:[],
  //       permission:'Pages.Customer.View',
  //     },
  //     {
  //       path:'/System/PhotosList',
  //       component:()=>import('@/views/System/PhotosList.vue'),
  //       name:'Rule',
  //       meta:{
  //         title:'图片集列表',
  //         icon:''
  //       },
  //       hidden:false,
  //       children:[],
  //       permission:'Pages.Customer.View',
  //     },
  //     {
  //       path:'/System/AgreementInfo',
  //       component:()=>import('@/views/System/AgreementInfo.vue'),
  //       name:'Rule',
  //       meta:{
  //         title:'合同信息管理',
  //         icon:''
  //       },
  //       hidden:false,
  //       children:[],
  //       permission:'Pages.Customer.View',
  //     } 
  //   ],
  //   hidden: false
  // },
  // {
  //   path: '/welcome',
  //   component:Layout,
  //   name:'welcome',
  //   meta:{
  //     title:'welcome',
  //     icon:''
  //   },
  //   hidden:true,
  //   children:[{
  //     path:'',
  //     name:'welcome',
  //     component:()=>import('@/views/welcome/welcome'),
  //     meta:{title:'welcome',icon:''},
  //     children:[],
  //     hidden:true
  //   }],
  // },
  {
    path: '/401',
    meta:{title:'401'},
    icon:'',
    component: () => import('@/views/401'),
    children:[],
    hidden: true
  },
  {
    path: '/404',
    meta:{title:'404'},
    icon:'',
    component: () => import('@/views/404'),
    children:[],
    hidden: true
  },
  {
    path: '/home',
    component:Layout,
    name:'home',
    meta:{
      title:'首页',
      icon:''
    },
    hidden:true,
    children:[{
      path:'/home/index',
      name:'home',
      component:()=>import('@/views/home/index'),
      meta:{title:'首页',icon:''},
      children:[],
      hidden:false
    }],
  },
  {
    path: '/OrderReport',
    component:Layout,
    name:'NewOrderReport',
    meta:{
      title:'新单销售额',
      icon:''
    },
    hidden:true,
    children:[
      {
        path:'/OrderReport/newOrder',
        name:'NewOrderReport',
        component:()=>import('@/views/OrderReport/newOrder'),
        meta:{title:'新单销售额',icon:''},
        children:[],
        hidden:true
      },
      {
        path:'/OrderReport/upOrder',
        name:'NewOrderReport',
        component:()=>import('@/views/OrderReport/upOrder'),
        meta:{title:'升级单销售额',icon:''},
        children:[],
        hidden:true
      }
    ],
  },
  {
    path: '/welcome',
    component:Layout,
    name:'welcome',
    meta:{
      title:'welcome',
      icon:''
    },
    hidden:true,
    children:[{
      path:'',
      name:'welcome',
      component:()=>import('@/views/welcome/welcome'),
      meta:{title:'welcome',icon:''},
      children:[],
      hidden:true
    }],
  },
  { path: '*', redirect: '/404',children:[], hidden: true },
]

export const constantSystemRoutes = [  
  {
    path: '/Agreement',
    meta:{title:'合同管理',icon:'',},
    
    // component: () => import('@/views/largeScreen/index'),
    component:Layout,
    name:'AgreementManage',
    children:[
      {
        path:'/Agreement/List',
        component:()=>import('@/views/Agreement/List.vue'),
        name:'Customer',
        meta:{
          title:'合同管理',
          icon:''
        },
        hidden:false,
        children:[],
        permission:'Pages.Customer.View',
      }
    ],
    hidden: false
  },
  {
    path: '/Work',
    meta:{title:'工作管理',icon:'',},
    
    // component: () => import('@/views/largeScreen/index'),
    component:Layout,
    name:'Work',
    children:[
      {
        path:'/Work/Scheduling',
        component:()=>import('@/views/Work/List.vue'),
        name:'Customer',
        meta:{
          title:'排班管理',
          icon:''
        },
        hidden:false,
        children:[],
        permission:'Pages.Customer.View',
      }
    ],
    hidden: false
  },
  {
    path: '/rule',
    meta:{title:'系统设置',icon:'',},
    
    // component: () => import('@/views/largeScreen/index'),
    component:Layout,
    name:'System',
    children:[
      {
        path:'/System/Rule',
        component:()=>import('@/views/System/Rule.vue'),
        name:'Rule',
        meta:{
          title:'角色管理',
          icon:''
        },
        hidden:false,
        children:[],
        permission:'Pages.Customer.View',
      },
      {
        path:'/System/UserRule',
        component:()=>import('@/views/System/UserRule.vue'),
        name:'Rule',
        meta:{
          title:'角色管理',
          icon:''
        },
        hidden:true,
        children:[],
        permission:'Pages.Customer.View',
      },
      {
        path:'/System/Project',
        component:()=>import('@/views/System/Project.vue'),
        name:'Rule',
        meta:{
          title:'模板管理',
          icon:''
        },
        hidden:false,
        children:[],
        permission:'Pages.Customer.View',
      },
      {
        path:'/System/ProjectDetail',
        component:()=>import('@/views/System/ProjectDetail.vue'),
        name:'Rule',
        meta:{
          title:'模板详情',
          icon:''
        },
        hidden:true,
        children:[],
        permission:'Pages.Customer.View',
      },
      {
        path:'/System/PhotosType',
        component:()=>import('@/views/System/PhotosType.vue'),
        name:'Rule',
        meta:{
          title:'图片集分类',
          icon:''
        },
        hidden:false,
        children:[],
        permission:'Pages.Customer.View',
      },
      {
        path:'/System/PhotosList',
        component:()=>import('@/views/System/PhotosList.vue'),
        name:'Rule',
        meta:{
          title:'图片集列表',
          icon:''
        },
        hidden:false,
        children:[],
        permission:'Pages.Customer.View',
      },
      {
        path:'/System/AgreementInfo',
        component:()=>import('@/views/System/AgreementInfo.vue'),
        name:'Rule',
        meta:{
          title:'合同信息管理',
          icon:''
        },
        hidden:false,
        children:[],
        permission:'Pages.Customer.View',
      } 
    ],
    hidden: false
  },
  {
    path: '/welcome',
    component:Layout,
    name:'welcome',
    meta:{
      title:'welcome',
      icon:''
    },
    hidden:true,
    children:[{
      path:'',
      name:'welcome',
      component:()=>import('@/views/welcome/welcome'),
      meta:{title:'welcome',icon:''},
      children:[],
      hidden:true
    }],
  },

]

export const constantRoutes = [
  // {
  //   path:'/CustomerManage',
  //   component:Layout,
  //   name:'CustomerManage',
  //   meta:{
  //     title:'CustomerManage',
  //     icon:'iconhetong'
  //   },
  //   permission:'Pages.Customer.View',
  //   hidden:false,
  //   children:[
  //     {
  //       path:'/CustomerManage/Customer',
  //       component:()=>import('@/views/CustomerManage/Customer.vue'),
  //       name:'Customer',
  //       meta:{
  //         title:'Customer',
  //         icon:''
  //       },
  //       hidden:false,
  //       children:[],
  //       permission:'Pages.Customer.View',
  //     }
  //   ]
  // },
  
  {
    path:'/StockManage',
    component:Layout,
    name:'StockManage',
    meta:{
      title:'StockManage',
      icon:'iconhetong'
    },
    permission:'Pages.Order.View',
    hidden:false,
    children:[
      {
        path:'/StockManage/Stock',
        component:()=>import('@/views/StockManage/Stock.vue'),
        name:'Stock',
        meta:{
          title:'Stock',
          icon:''
        },
        hidden:false,
        children:[],
        permission:'Pages.Order.View',
      },
      {
        path:'/StockManage/DetailStock',
        component:()=>import('@/views/StockManage/StockDetail.vue'),
        name:'StockDetail',
        meta:{
          title:'StockDetail',
          icon:''
        },
        hidden:true,
        children:[],
        permission:'Pages.Order.View',
      },
    ]
  },
]

const createRouter = () => new Router({
  scrollBehavior:()=>({y:0}),
  routes:constantBaseRoutes,
  mode:'hash',
});

export const router = createRouter();

export function resetRouter(){
  const newRouter = createRouter()
  router.matcher = newRouter.matcher;
}
export default router


